// 202 -- bottom tab bar for the spectator persona (anonymous + signed-in
// roleless), per handoff S13: Discover / Following / Live. Rendered `< md`
// by PublicLayout and MinimalLayout; the role-based Layout keeps its own
// 5-tab bar. Fixed to the viewport bottom with safe-area padding -- hosts
// must reserve bottom space at `< md` (pb on main).
import { useLocation, useNavigate } from "react-router-dom";
import { Search, Heart, Radio } from "lucide-react";

const TABS = [
  { key: "discover", label: "Discover", to: "/discover", icon: Search },
  { key: "following", label: "Following", to: "/following", icon: Heart },
  { key: "live", label: "Live", to: "/live", icon: Radio },
] as const;

export function SpectatorTabBar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 flex items-stretch border-t border-border bg-background/95 pb-[env(safe-area-inset-bottom)] backdrop-blur md:hidden"
      data-region="spectator-tab-bar"
    >
      {TABS.map((tab) => {
        const active = location.pathname === tab.to;
        return (
          <button
            key={tab.key}
            type="button"
            data-tab={tab.key}
            data-active={active}
            onClick={() => navigate(tab.to)}
            className={`flex min-h-[56px] flex-1 flex-col items-center justify-center gap-0.5 py-1.5 text-[10px] font-medium transition-transform active:scale-[.96] ${
              active ? "text-primary" : "text-muted-foreground/60"
            }`}
          >
            <tab.icon className="h-5 w-5" aria-hidden />
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
